// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/ConfirmationPopup/styles.scss
// module id = 799
// module chunks = 0